import React, { useState, useRef, useEffect } from 'react';
import '../App.css';
import { Link } from 'react-router-dom';
import './HeroSection.css';

const YT_VIDEO_ID = 'Hp_Eg8NMfT0';

function HeroSection() {
    const [isPlaying, setIsPlaying] = useState(false);
    const playerRef = useRef(null);
    const playerReady = useRef(false);
    const heroVideoRef = useRef(null);

    // Force muted at the DOM-property level and kick off playback.
    // React's `muted` attribute doesn't reliably set the property, which
    // causes mobile browsers to block autoplay and show a blank hero.
    useEffect(() => {
        const v = heroVideoRef.current;
        if (!v) return;
        v.muted = true;
        v.defaultMuted = true;
        const tryPlay = () => {
            const p = v.play();
            if (p && typeof p.catch === 'function') p.catch(() => { });
        };
        tryPlay();
        // Retry once metadata is ready (helps slower mobile connections)
        v.addEventListener('loadeddata', tryPlay);
        return () => v.removeEventListener('loadeddata', tryPlay);
    }, []);

    useEffect(() => {
        const createPlayer = () => {
            if (playerRef.current) return;
            playerRef.current = new window.YT.Player('hero-yt-player', {
                videoId: YT_VIDEO_ID,
                playerVars: { autoplay: 0, loop: 1, playlist: YT_VIDEO_ID },
                events: {
                    onReady: () => { playerReady.current = true; },
                    onStateChange: (e) => {
                        if (e.data === window.YT.PlayerState.ENDED) {
                            e.target.playVideo();
                        }
                    },
                },
            });
        };

        if (window.YT && window.YT.Player) {
            createPlayer();
            return;
        }
        const tag = document.createElement('script');
        tag.src = 'https://www.youtube.com/iframe_api';
        document.head.appendChild(tag);
        window.onYouTubeIframeAPIReady = () => { createPlayer(); };
    }, []);

    const toggleMusic = () => {
        if (!playerReady.current || !playerRef.current) return;
        if (isPlaying) {
            playerRef.current.pauseVideo();
            setIsPlaying(false);
        } else {
            playerRef.current.playVideo();
            setIsPlaying(true);
        }
    };

    return (

        <div className='hero-container'>
            <video
                ref={heroVideoRef}
                className='hero-video-desktop'
                src='/videos/video1.mp4'
                autoPlay
                loop
                muted
                playsInline
                preload='auto'
            />
            <img className='hero-video-mobile' src='/images/roasting.jpg' alt='Coffee roasting' />
            {/* Musical notes - uncomment to re-enable
            <div className='hero-music-notes'>
                <span className='hero-music-note'>&#9835;</span>
                <span className='hero-music-note'>&#9834;</span>
                <span className='hero-music-note'>&#9833;</span>
                <span className='hero-music-note'>&#9835;</span>
            </div>
            */}
            <div className='hero-title-row'>
                <h1>ROAST WITH US</h1>
                <div className='coffee-bean-spinner'>
                    <svg viewBox="0 0 100 100" className='coffee-bean-svg'>
                        <ellipse cx="50" cy="50" rx="28" ry="40" fill="#fff" />
                        <path d="M50 12 C45 30, 45 70, 50 88" stroke="rgba(0,0,0,0.3)" strokeWidth="3" fill="none" />
                    </svg>
                </div>
            </div>
            <p>An Unforgettable Coffee Experience</p>
            <div className='hero-btns'>
                <Link to='/booking' className='btn-mobile'>
                    <button className='btn btn--outline btn--large'>
                        GET STARTED
                    </button>
                </Link>
                <Link to='/gallery' className='btn-mobile'>
                    <button className='btn btn--outline btn--large'>
                        MORE VIDEOS <i className='far fa-play-circle' />
                    </button>
                </Link>
                <a href='https://jazzgroove.org/stream?channel=mix1' className='hero-jazz-logo-link'
                    onClick={(e) => { e.preventDefault(); window.open('https://jazzgroove.org/stream?channel=mix1', 'newwindow', 'width=600,height=700'); }}>
                    <img
                        src='/images/Java & Jazz Groove3.png'
                        alt='The Jazz Groove'
                        className='hero-jazz-logo'
                    />
                </a>
            </div>


            <div id='hero-yt-player' className='hero-yt-hidden' />
        </div>

    )
}

export default HeroSection
